<template>
    <div>
        <div class="steps">
            <div class="step" :class="{'active':step>=1}"><span class="material-icons">person</span></div>
            <div class="step" :class="{'active':step>=2}"><span class="material-icons">vpn_key</span></div>
            <div class="step" :class="{'active':step>=3}"><span class="material-icons">check</span></div>
        </div>
        <div class="content">
            <transition-group name="fade" mode="out-in">
                <div v-if="step == 1" key="1" class="userDetails">
                    <div class="form-group">
                        <label for="firstname">Vārds</label>
                        <input id="firstname" type="text" v-model="firstname" class="form-control"  :class="{'is-invalid':errors && ( 'firstname' in errors)}">
                        <small class="text-danger" v-if="errors && errors.firstname">{{errors.firstname[0]}}</small>
                    </div>
                    <div class="form-group">
                        <label for="lastname">Uzvārds</label>
                        <input id="lastname" type="text" v-model="lastname" class="form-control"  :class="{'is-invalid':errors && ( 'lastname' in errors)}">
                        <small class="text-danger" v-if="errors && errors.lastname">{{errors.lastname[0]}}</small>
                    </div>
                    <div class="form-group">
                        <label for="position">Amats</label>
                        <input id="position" type="text" v-model="position" class="form-control"  :class="{'is-invalid':errors && ( 'position' in errors)}">
                        <small class="text-danger" v-if="errors && errors.position">{{errors.position[0]}}</small>
                    </div>
                    <div class="form-group">
                        <label for="phone">Tālrunis</label>
                        <input id="phone" type="text" v-model="phone" class="form-control"  :class="{'is-invalid':errors && ( 'phone' in errors)}">
                        <small class="text-danger" v-if="errors && errors.phone">{{errors.phone[0]}}</small>
                    </div>
                    <div class="form-group">
                        <label for="email">E-pasts</label>
                        <input id="email" type="text" v-model="email" class="form-control" disabled>
                        <small class="text-muted">E-pasta adresi nav iespējams mainīt.</small>
                    </div>
                    <div class="form-group">
                        <button @click="saveDetails(1)" class="btn btn-primary">Saglabāt un turpināt</button>
                    </div>
                </div>
                <div v-if="step == 2" key="2" class="userPassword">
                    <div class="infoMessage">
                        <div class="alert alert-info">
                            Parole būs nepieciešama, lai pieslēgtos sistēmai. Minimālais paroles garums  - 8 simboli.
                        </div>

                    </div>
                    <div class="form-group">
                        <label for="password1">Parole</label>
                        <input id="password1" type="password" v-model="password1" class="form-control"  :class="{'is-invalid':errors && ( 'password1' in errors)}">
                        <small class="text-danger" v-if="errors && errors.password1">{{errors.password1[0]}}</small>
                    </div>
                    <div class="form-group">
                        <label for="password2">Parole (atkārtoti)</label>
                        <input id="password2" type="password" v-model="password2" class="form-control"  :class="{'is-invalid':errors && ( 'password2' in errors)}">
                        <small class="text-danger" v-if="errors && errors.password2">{{errors.password2[0]}}</small>
                    </div>
                    <div class="form-group">
                        <button  @click="saveDetails(2)" class="btn btn-primary">Saglabāt un turpināt</button>
                    </div>
                </div>
                <div v-if="step == 3" key="3" class="success">
                    <div class="form-group text-center">
                        <a href="/login" class="btn btn-primary text-white">Uz sistēmu</a>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
export default {
    props:['user'],
    data() {
        return {
            id:"",
            register_token:"",
            firstname:"",
            lastname:"",
            email:"",
            position:"",
            phone:"",
            password1:"",
            password2:"",
            reset_token:"",
            step:1,
            errors:[],
            message:null,
            loading: true
        }
    },
    mounted()
    {
        this.firstname = this.$props.user.firstname;
        this.id = this.$props.user.id;
        this.register_token = this.$props.user.register_token;
        this.lastname = this.$props.user.lastname;
        this.email = this.$props.user.email;
        this.position = this.$props.user.position;
        this.phone = this.$props.user.phone;


    },
    methods:
        {
            changeStep(step)
            {
                this.step = step;
            },
            saveDetails(step){
                this.loading = true;
                var that = this;
                if (step == 1)
                {
                    axios.post('/registration/api/user/'+that.id+'/'+that.register_token+'/'+step,
                        {
                            firstname: this.firstname,
                            lastname: this.lastname,
                            position: this.position,
                            phone: this.phone,
                        }
                    )
                        .then(response => {
                            if (response.data.status == 'ok')
                            {
                                that.loading = false;
                                that.step = that.step + 1;
                                console.log('ok');
                            }
                            else
                            {
                                that.errors = response.data.errors;
                            }

                        })
                }
                else if( step == 2)
                {
                    axios.post('/registration/api/user/'+that.id+'/'+that.register_token+'/'+step,
                        {
                            password1:this.password1,
                            password2:this.password2
                        }
                    )
                        .then(response => {
                            if (response.data.status == 'ok')
                            {
                                that.loading = false;
                                that.step = that.step + 1;
                            }
                            else
                            {
                                that.errors = response.data.errors;
                            }

                        })

                }


            }
        }
}
</script>

<style lang="scss" scoped>
.steps{
    display:flex;
    justify-content: space-between;
    padding-bottom:30px;
    border-bottom: solid 2px #eee;
    .step{
        font-size:28px;
        line-height:1;
        display: flex;
        justify-content: center;
        align-items: center;
        background:#aaa;
        width:50px;
        height:50px;
        border-radius:100%;
        color:#fff;
        cursor:not-allowed;
        &.active{
            background-color:#3867d6;
            cursor:pointer;
        }
    }
}
.content{
    margin-top:20px;
}
.fade-enter-active, .fade-leave-active {
    transition: all .5s;
    height:auto;
    opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    height:0;

}
</style>
